module.exports = __webpack_public_path__ + "img/search-small-sentosa.965b25f7.svg";